module.exports = __webpack_public_path__ + "assets/img/scenic_07.901bbd71.svg";